"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _CVLMIMPTcjs = require('./CVLMIMPT.cjs');





var _WMTGHDLEcjs = require('./WMTGHDLE.cjs');


var _4TRESXTOcjs = require('./4TRESXTO.cjs');

// src/popover/popover-store.ts
function createPopoverStore({
  popover: otherPopover,
  ...props
} = {}) {
  const store = _WMTGHDLEcjs.mergeStore.call(void 0, 
    props.store,
    _WMTGHDLEcjs.omit.call(void 0, otherPopover, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  _WMTGHDLEcjs.throwOnConflictingProps.call(void 0, props, store);
  const syncState = store == null ? void 0 : store.getState();
  const dialog = _CVLMIMPTcjs.createDialogStore.call(void 0, { ...props, store });
  const placement = _4TRESXTOcjs.defaultValue.call(void 0, 
    props.placement,
    syncState == null ? void 0 : syncState.placement,
    "bottom"
  );
  const initialState = {
    ...dialog.getState(),
    placement,
    currentPlacement: placement,
    anchorElement: _4TRESXTOcjs.defaultValue.call(void 0, syncState == null ? void 0 : syncState.anchorElement, null),
    popoverElement: _4TRESXTOcjs.defaultValue.call(void 0, syncState == null ? void 0 : syncState.popoverElement, null),
    arrowElement: _4TRESXTOcjs.defaultValue.call(void 0, syncState == null ? void 0 : syncState.arrowElement, null),
    rendered: /* @__PURE__ */ Symbol("rendered")
  };
  const popover = _WMTGHDLEcjs.createStore.call(void 0, initialState, dialog, store);
  return {
    ...dialog,
    ...popover,
    setAnchorElement: (element) => popover.setState("anchorElement", element),
    setPopoverElement: (element) => popover.setState("popoverElement", element),
    setArrowElement: (element) => popover.setState("arrowElement", element),
    render: () => popover.setState("rendered", /* @__PURE__ */ Symbol("rendered"))
  };
}



exports.createPopoverStore = createPopoverStore;
